/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// react-flatpickr components
import Flatpickr from 'react-flatpickr';
import InputAdornment from '@mui/material/InputAdornment';
import Icon from '@mui/material/Icon';

// react-flatpickr styles
import 'flatpickr/dist/flatpickr.css';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';

import * as Func from 'services/Function';

function MDDatePicker({ input, readOnly, ...rest }) {
  if (readOnly)
    return (
      <MDInput
        {...input}
        value={Func.dateFormatDisplay(rest.value)}
        InputProps={{ readOnly: true }}
      />
    );

  return (
    <Flatpickr
      {...rest}
      options={{
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'd-m-Y',
      }}
      render={({ defaultValue }, ref) => (
        <MDInput
          {...input}
          defaultValue={defaultValue}
          inputRef={ref}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <Icon>calendar_month</Icon>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}

// Setting default values for the props of MDDatePicker
MDDatePicker.defaultProps = {
  input: {},
  readOnly: false,
};

// Typechecking props for the MDDatePicker
MDDatePicker.propTypes = {
  readOnly: PropTypes.bool,
  input: PropTypes.objectOf(PropTypes.any),
};

export default MDDatePicker;
